import React, { useState } from "react";
import { SeoHelmet, LazyLoad } from "../common/Functions";
import { Link } from "@reach/router";

function Home() {
  const [isSkillSpectrumActive, setIsSkillSpectrumActive] = useState(true);
  const [isInvolvementsActive, setIsInvolvementsActive] = useState(false);
  const [isCreationsActive, setIsCreationsActive] = useState(false);

  return (
    <main className="px-6 mx-auto max-w-screen-lg lg:px-10">
      <SeoHelmet
        title="Software Engineer"
        description="Software Engineer - since 2015"
        link="/"
      />
      <div className="container flex flex-col flex-wrap items-center justify-between px-0 py-10 mx-auto md:flex-row">
        <div className="flex flex-col w-full items-left">
          <div className="mt-8 content lg:mt-12 md:mt-10 sm:mt-8">
            <div className="flex flex-col items-center md:flex-row">
              <div className="rounded-lg bg-theme-color lg:mr-12 md:mr-10 overflow-hidden w-16 h-16 mb-4">
                <LazyLoad
                  className="inline-auto alvin-dp"
                  src={require("../common/images/alvin_dp_3.png")}
                  alt="Alvin Profile"
                />
              </div>
              <div class="flex flex-col items-center md:items-start">
                <a
                  href="https://github.com/alvnrapada"
                  target="blank"
                  className="text-sm font-bold text-center md:text-right text-theme-color flex flex-row items-center mb-2"
                >
                  <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    class="h-4 w-4 mr-3 fill-gray-900"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 2C6.477 2 2 6.463 2 11.97c0 4.404 2.865 8.14 6.839 9.458.5.092.682-.216.682-.48 0-.236-.008-.864-.013-1.695-2.782.602-3.369-1.337-3.369-1.337-.454-1.151-1.11-1.458-1.11-1.458-.908-.618.069-.606.069-.606 1.003.07 1.531 1.027 1.531 1.027.892 1.524 2.341 1.084 2.91.828.092-.643.35-1.083.636-1.332-2.22-.251-4.555-1.107-4.555-4.927 0-1.088.39-1.979 1.029-2.675-.103-.252-.446-1.266.098-2.638 0 0 .84-.268 2.75 1.022A9.607 9.607 0 0 1 12 6.82c.85.004 1.705.114 2.504.336 1.909-1.29 2.747-1.022 2.747-1.022.546 1.372.202 2.386.1 2.638.64.696 1.028 1.587 1.028 2.675 0 3.83-2.339 4.673-4.566 4.92.359.307.678.915.678 1.846 0 1.332-.012 2.407-.012 2.734 0 .267.18.577.688.48 3.97-1.32 6.833-5.054 6.833-9.458C22 6.463 17.522 2 12 2Z"
                    ></path>
                  </svg>

                  <span className="font-medium text-theme-color hover:underline">
                    alvnrapada
                  </span>
                </a>
                <p className="text-sm font-bold text-center md:text-right text-theme-color md:flex md:flex-row md:items-center mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3 w-3 mr-3 text-gray-600 hidden md:block"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                    />
                  </svg>
                  <span className="font-medium text-theme-color hover:underline">
                    <a href="mailto:alvnrapada@gmail.com">
                      {" "}
                      alvnrapada@gmail.com
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="mt-10 content lg:mt-12 md:mt-10 sm:mt-8">
            <div className="flex flex-row justify-between list">
              <p className="text-base mb-3 text-left text-gray-600">
                Hi, I'm <span className="font-semibold text-black">Alvin.</span>{" "}
                A{" "}
                <span className="font-semibold text-black">
                  Software Engineer
                </span>{" "}
                based in the Philippines.
              </p>
            </div>
          </div>
          <div className="accordion mt-10 lg:mt-12 md:mt-10 sm:mt-8">
            <div className="accordion-item">
              <div
                className="accordion-title flex items-center cursor-pointer"
                onClick={() => setIsSkillSpectrumActive(!isSkillSpectrumActive)}
              >
                <p className="text-base font-bold text-center md:text-left flex flex-row items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3 w-3 mr-3 text-gray-600"
                    fill={isSkillSpectrumActive ? "currentColor" : "none"}
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
                    />
                  </svg>

                  <span className="font-bold">technical know-how</span>
                </p>
              </div>
              {isSkillSpectrumActive && (
                <div className="content mt-10 mb-6" id="technologies">
                  <div className="flex flex-col md:flex-row justify-between list">
                    <ul className="w-full md:w-1/4">
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a
                          href="https://www.phoenixframework.org/"
                          target="blank"
                        >
                          Phoenix Framework
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a href="https://elixir-lang.org/" target="blank">
                          Elixir
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a href="https://tailwindcss.com/" target="blank">
                          TailwindCSS
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a
                          href="https://github.com/alpinejs/alpine"
                          target="blank"
                        >
                          AlpineJS
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a
                          href="https://alvinrapada.medium.com/"
                          target="blank"
                        >
                          LiveView
                        </a>
                      </li>
                    </ul>
                    <ul className="w-full md:w-1/2">
                      <li className="mb-3 text-gray-600">
                        {" "}
                        OAuth 2.0 (Standard / PKCE Flow)
                      </li>
                      <li className="mb-3 text-gray-600">
                        POW Auth / Überauth
                      </li>
                      <li className="mb-3 text-gray-600">
                        GraphQL API / OpenAPI
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a
                          href="https://alvinrapada.medium.com/creating-unique-constraint-index-ecto-migration-elixir-37146722e593"
                          target="blank"
                        >
                          Postgres / Ecto / Hex
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600">
                        GenServer / ETS / Cachex
                      </li>
                    </ul>
                    <ul className="w-full md:w-1/3">
                      <li className="mb-3 text-gray-600">Oban/Quantum</li>
                      <li className="mb-3 text-gray-600">
                        <a
                          href="https://stripe.com/docs/api/subscriptions"
                          target="blank"
                          className="hover:underline"
                        >
                          Stripe Integration
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a
                          href="https://sendbird.com/docs/business-messaging/guide/v2/overview"
                          target="blank"
                        >
                          Sendbird Integration
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a href="https://fly.io/" target="blank">
                          Fly.io
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600">NuxtJS / VueJS</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="accordion mt-4">
            <div className="accordion-item">
              <div
                className="accordion-title flex items-center cursor-pointer"
                onClick={() => setIsCreationsActive(!isCreationsActive)}
              >
                <p className="text-base font-bold text-center md:text-left flex flex-row items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3 w-3 mr-3 text-gray-600"
                    fill={isCreationsActive ? "currentColor" : "none"}
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M4.867 19.125h.008v.008h-.008v-.008Z"
                    />
                  </svg>

                  <span className="font-bold">weekend projects</span>
                </p>
              </div>
              {isCreationsActive && (
                <div className="content mt-10 mb-6" id="creations">
                  <div className="flex flex-col md:flex-row justify-between list">
                    <ul className="w-full md:w-1/4">
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a href="https://prayedfor.me/" target="blank">
                          PrayedForMe
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600 hover:underline">
                        <a href="https://milksisters.app/" target="blank">
                          MilkSisters
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="accordion mt-4">
            <div className="accordion-item">
              <div
                className="accordion-title flex items-center cursor-pointer"
                onClick={() => setIsInvolvementsActive(!isInvolvementsActive)}
              >
                <p className="text-base font-bold text-center md:text-left flex flex-row items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3 w-3 mr-3 text-gray-600"
                    fill={isInvolvementsActive ? "currentColor" : "none"}
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    />
                  </svg>
                  <span className="font-bold">involvements</span>
                </p>
              </div>
              {isInvolvementsActive && (
                <div
                  className="content mt-10 mb-6"
                  id="experiences&involvements"
                >
                  <div className="flex flex-col justify-between mt-3 list">
                    <p className="mb-3 text-gray-500 text-xs">Companies</p>
                    <ul className="mb-3">
                      <li className="mb-3 text-gray-600">
                        Software Engineer &mdash;{" "}
                        <a
                          href="https://www.truefirestudios.com/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          TrueFire Studios
                        </a>{" "}
                        <span className="text-gray-500 text-xs">
                          (Current - since Feb 2025)
                        </span>
                      </li>
                      <li className="mb-3 text-gray-600">
                        Phoenix/Elixir Developer &mdash;{" "}
                        <a
                          href="https://blayze.io/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          Blayze
                        </a>{" "}
                        <span className="text-gray-500 text-xs">
                          (Jan 2021 - Feb 2025)
                        </span>
                      </li>
                      {/* <li className="mb-3 text-gray-600">Phoenix/Elixir Developer &mdash; <a href="https://fino.group/" target="blank" className="font-bold text-theme-color underline">Fino Data Services GmbH</a> <span className="text-gray-500 text-xs">(Part-Time - since Sept 2024)</span> */}
                      {/* </li> */}
                      <li className="mb-3 text-gray-600">
                        Lead Software Engineer &mdash;{" "}
                        <a
                          href="https://pragtechnologies.com"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          Pragtechnologies
                        </a>{" "}
                        &{" "}
                        <a
                          href="https://www.seeyoudoc.com/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          SeeYouDoc
                        </a>{" "}
                        <span className="text-gray-500 text-xs">
                          (Aug 2015 - Oct 2021)
                        </span>
                      </li>
                    </ul>
                    <p className="mb-3 text-gray-500 text-xs">
                      Projects & Roles
                    </p>
                    <ul className="mb-3">
                      <li className="mb-3 text-gray-600">
                        <a
                          href="https://blayze.io/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          Blayze App
                        </a>{" "}
                        &mdash; Elixir Developer{" "}
                        <span className="text-gray-500 text-xs">
                          (5 year project)
                        </span>
                      </li>
                      <li className="mb-3 text-gray-600">
                        <a
                          href="https://www.seeyoudoc.com/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          SeeYouDoc App
                        </a>{" "}
                        &mdash; Lead Elixir Developer{" "}
                        <span className="text-gray-500 text-xs">
                          (4 year project)
                        </span>
                      </li>
                      <li className="mb-3 text-gray-600">
                        <a
                          href="https://loisysalvacion.netlify.app/works/nac-cmc-omt"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          NAC CMC-OMT
                        </a>{" "}
                        &mdash; Elixir Developer{" "}
                        <span className="text-gray-500 text-xs">
                          (3 year project)
                        </span>
                      </li>
                      <li className="mb-3 text-gray-600">
                        <a
                          href="https://www.textstack.io/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          TextStack
                        </a>{" "}
                        &mdash; Fullstack Developer{" "}
                        <span className="text-gray-500 text-xs">
                          (2 year project)
                        </span>
                      </li>
                      <li className="mb-3 text-gray-600">
                        <a
                          href="https://loisysalvacion.netlify.app/works/aims"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          AIMS
                        </a>{" "}
                        &mdash; Front-End Developer{" "}
                        <span className="text-gray-500 text-xs">
                          (1 year project)
                        </span>
                      </li>
                    </ul>

                    <p className="mb-3 text-gray-500 text-xs">hackathons</p>
                    <ul>
                      <li className="mb-3 text-gray-600">
                        ADB-AIM Hack <em>(Finalist)</em> Aug 2018 &mdash;{" "}
                        <a
                          href="https://ultrahack.org/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          Ultrahack
                        </a>
                      </li>
                      <li className="mb-3 text-gray-600">
                        Turku Business Region Ultrahack <em>(2nd Place)</em> Oct
                        2018 &mdash;{" "}
                        <a
                          href="https://ultrahack.org/"
                          target="blank"
                          className="font-bold text-theme-color underline"
                        >
                          Ultrahack
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          <Link
            id="stories"
            to="/stories"
            className="mt-4 text-base font-bold text-center md:text-left flex flex-row items-center hover:underline"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="h-3 w-3 mr-3 text-gray-600"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
              />
            </svg>
            <span className="font-bold">stories</span>
          </Link>

          <Link
            id="tips"
            to="/tips"
            className="mt-4 mb-20 text-base font-bold text-center md:text-left flex flex-row items-center hover:underline"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="h-3 w-3 mr-3 text-gray-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
              />
            </svg>
            <span className="font-bold">self tips</span>
          </Link>
        </div>
      </div>
    </main>
  );
}

export default Home;
